import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton, Typography } from "@mui/material";
import UserContext from "../../context/user-context"; // Updated import
import { useStyles } from "./styles"; 
import ProfileIcon from "../ProfileIcon/ProfileIcon";

const Navbar = ({ title, sideMenuVisible, toggleSideMenu }) => {
  const classes = useStyles();
  const location = useLocation();
  const userCtx = useContext(UserContext); // Updated to UserContext

  const getPageTitle = () => {
    switch (location.pathname) {
      case "/":
        return `Welcome ${userCtx?.userName || "User"}!`;
      case "/scan":
        return "New scan";  
      case "/general-scan":
        return "General scan"; 
      case "/doc-extraction":
        return "General extraction"; 
      case "/merger":
        return "Merge Documents"; 
      case "/ocr-scanner":
        return "OCR Scanner";
      case "/my-invoices":
        return "My Invoices";	 
      case "/my-expenses":
        return "My Expenses";	 
      case "/add-expenses":
        return "Add Expenses"; 
      case "/history":
        return "All scans";	
      case "/users":
        return "Manage users";  
      case "/vendors":
        return "Manage vendors";
      case "/companies":
        return "Manage companies";	
      case "/expense-reimbursements":
        return "Expense Reimbursements";	
        case "/expense-reimbursements-history":
          return "Expense Inbox History";	
      case "/drms":
        return "Document Management";
      case "/audits":
        return "Audit Records";
      case "/settings":
        return `${title}`;
      default:
        return "";
    }
  };


  return (
    <div className={classes.rootContainer}>
      <div className={classes.headingContainer}>
        {!sideMenuVisible && (
          <IconButton onClick={toggleSideMenu} sx={{
            "@media (max-width:768px)": {
              display: "none",
            },
          }}>
            <MenuIcon
              sx={{
                color: "#354a5f",
                "&:hover": {
                  color: "white",
                },
                marginTop: "-4px",
              }}
            />
          </IconButton>
        )}
        <Typography
          variant="h5"
          sx={{
            ml: 4,
            fontSize: { xs: "20px", sm: "24px", md: "26px" },
            fontFamily: "SapFiori72, sans-serif",
          }}
        >
          {getPageTitle()}
        </Typography>
      </div>
      <div className={classes.rightButtons}>
        <span
          style={{
            marginRight: 10,
            fontSize: { xs: "20px", sm: "24px", md: "26px" },
            fontFamily: "SapFiori72, sans-serif",
          }}
        >
          {userCtx.userName || "User"}
        </span>
        <ProfileIcon avatar={userCtx.avatar} />
      </div>
    </div>
  );
};

export default Navbar;
